module.exports = __webpack_public_path__ + "img/vendor3.c1076a3b.jpg";